"use client";

import { StoryFactValues, useStoryFactsActive } from "@/components/sections/story/StoryFacts";

export function SideStoryFacts() {
  const active = useStoryFactsActive(0);

  return (
    <div className="facts_set f f-c">
      <StoryFactValues active={active} />
    </div>
  );
}
